import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/* eslint-disable react-hooks/rules-of-hooks */
import { useCallback, useState } from 'react';
export function useOpenState(_ref) {
  var open = _ref.open,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose;
  var setIsOpenState = null;
  if (open === undefined || open === null) {
    // The component is uncontrolled, so we need to give it its own state.
    var _useState = useState(false);
    var _useState2 = _slicedToArray(_useState, 2);
    open = _useState2[0];
    setIsOpenState = _useState2[1];
  } // prettier-ignore

  var setIsOpen = useCallback(function (newIsOpen) {
    setIsOpenState && setIsOpenState(newIsOpen);
    return newIsOpen ? onOpen && onOpen() : onClose && onClose();
  }, [onOpen, onClose, setIsOpenState]);
  return {
    isOpen: open,
    setIsOpen: setIsOpen
  };
}